export default __webpack_public_path__ + "static/media/group54.94b2458c.svg";